import { Table } from '@octano/global-ui';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Col, Row } from 'reactstrap';
import SectionTitle from '../../../../components/Text/SectionTitle';
import TableEmptyContent from '../../../../components/Text/TableEmptyContent';
import { TranslationsKeys } from '../../../../locales/translations';
import { useColumnsLearningUnits } from '../../hooks/useColumnsLearningUnits';
import { CourseFormFields } from '../../types/details';

const LearningUnitSection = () => {
  const { t } = useTranslation(TranslationsKeys.COURSES_DETAILS);

  const { watch } = useFormContext<CourseFormFields>();
  const learningUnits = watch('learningUnits');

  const columns = useColumnsLearningUnits();

  return (
    <>
      <Row>
        <Col
          xs={12}
          className="d-flex justify-content-between align-items-center p-4"
        >
          <SectionTitle text={t(`learningUnit.title`)} />
        </Col>
        <Col xs={12}>
          <Table
            columns={columns}
            data={learningUnits ?? []}
            noResultsText={
              <TableEmptyContent
                title={t(`learningUnit.table.empty.title`)}
                subtitle={''}
              />
            }
          />
        </Col>
      </Row>
    </>
  );
};

export default LearningUnitSection;
